import 'react-app-polyfill/stable';
//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
///////////////////////////////////////////////////////////   COMPS
import App from './App';
///////////////////////////////////////////////////////////   SETTING
import { _SETTINGS } from 'config/settings';
///////////////////////////////////////////////////////////   CSS
import './index.css';
//////////////////////////////////////////////////////////////////////////////////////   RENDER
ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById(_SETTINGS.basic.generalPlayerName)
);
